import {
    SheinDetail,
    editSheinDetail,
    SheinBrandList,
    sheinCategoryProps,
    getSheinSiteListApi,
    getCustomAttributeApi,
    addCustomAttributeApi,
} from '@/api/prod/center/index';
import store from '@/store'
import Vue from 'vue';

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
    if (r.skuList && r.skuList.length > 0) {
        r.skuList = r.skuList.map(item => {
            delete item._skuid
            return isRequest ? {
                ...item,
                imageUrl: item.skuSpecifications[0].imageUrl,
                marketPrice: item.marketPrice || 0,
                skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : [])
            } : {
                ...item,
                skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : []
            }
        })
    }

    return isRequest ? {
        ...r,
        categoryLeafId: r.categoryIds[r.categoryIds.length - 1],
        parentCategoryId: r.categoryIds[r.categoryIds.length - 2],
        categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
        specifications: JSON.stringify(r.specifications ? r.specifications : []),
    } : {
        ...r,
        attrs: r.attrs ? r.attrs : [],
        categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
        // headImgs: r.headImgs ? JSON.parse(r.headImgs) : [],
        // descInfo: r.descInfo ? JSON.parse(r.descInfo) : [],
        specifications: r.specifications ? JSON.parse(r.specifications) : [],
        templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : [],
        productType: 1, // 目前只支持实物商品
    }
}
// 获取详情资料
export function getSheinDetail(baseItemId) {
    return SheinDetail(baseItemId).then(res => {
        if (res.result === 1) {
            return _formatGoodsItem(res.data)
        } else {
            return false
        }
    })
}

export function editSheinInfo(params) {
    return editSheinDetail(_formatGoodsItem(params, true)).then(res => {
        if (res.result === 1) {
        return true;
        }
        return false;
    })
}

// 获取品牌列表
export async function queryBrandList(data) {
    return SheinBrandList(data).then(res => {
        if (res.result === 1) {
            return res;
        }
        return false;
    })
}
// 获取商品属性
export function getCategoryProps(data) {
    let _shopId = store.getters.shops_getCategoryPropShopId('shein')
    let _data = {
      ...data,
      shopId: data.shopId ? data.shopId : _shopId // 默认店铺
    }
    if(!_data.shopId) {
      Vue.prototype.$message.error('没有已授权的店铺！');
      return false
    }
    return sheinCategoryProps(_data).then(res => {
        return res
    })
  }
//查询是否支持自定义属性值
export function getCustomAttributePermissionConfig(data) {
    let _shopId = store.getters.shops_getCategoryPropShopId('shein')
    let _data = {
      ...data,
      shopId: data.shopId ? data.shopId : _shopId // 默认店铺
    }
    if(!_data.shopId) {
      Vue.prototype.$message.error('没有已授权的店铺！');
      return false
    }
    return getCustomAttributeApi(_data).then(res => {
        return res
    })
  }
  // 添加自定义属性
  export function addCustomAttribute(data,shopId){
    return addCustomAttributeApi(data,shopId).then(res => {
        return res
    })
  }
  // 获取站点列表
  export function getSheinSiteList(data){
    return getSheinSiteListApi(data).then(res => {
        return res
    })
  }